export default {
  'assetprotectionfaqs': {
    'assetprotectionfaqschild': 'asset_protection_faq',
    'accountprotection': 'account_protection',
    'financialinformation': 'financial_information'
  },
  'privacystatement': {
    'privacy': 'privacy_policy',
    'cookienotice': 'cookie_notice',
    'EMEAprivacynotice': 'emea_privacy',
    'hsbcprivacynotices': 'hsbc_privacy_notices'
  },
  'brokeragedisclosure': {
    'businesscontinuity': 'business_continuity',
    'nasdaqomxterms': 'nasdaq_omx_terms',
    'exchangeagreements': 'exchange_agreements',
    'orderflow': 'order_flow',
    'mutualfundsdisclosure': 'mutual_funds_disclosure',
    'margin': 'margin_disclosure',
    'orderrouting': 'order_routing_disclosure',
    'stoporderrisksandvolatilemarkets': 'stop_order_risks_and_volatile_markets',
    'digitalauthorization': 'digital_authorization_terms',
    'portfolioplus-agreement': 'portfolioplus_user_agreement',
    'statementdisclosure': 'statement_disclosure',
    'otherdisclosures': 'other_disclosures',
    'farmersdisclosure': 'farmers_disclosure',
    'investmentriskdisclaimer': 'investment_risk_disclaimer',
    'efsiempowerdisclosure': 'efsi_empower_disclosure',
    'bankcustodytermsandconditions' : 'bank_custody_terms_and_conditions',
    'boscprivacypolicy': 'bosc_privacy_policy',
    'boscdisclosures': 'bosc_disclosures',
    'definitions': 'definitions',
    'sitespecificresource': 'site_specific_resources',
    'bankdepositsweepdisclosure': 'bank_deposit_sweep_disclosure',
    'invertissecurityrecommendations': 'invertis_security_recommendations',
    'fractionalSharesDisclosure':'fractional_shares_disclosures',
    'victorydisclosures':'victory_disclosures',
    'about_us':'about_us'
  },
  'bankcustodydisclosures': {
    'privacypolicy': 'bank_custody_privacy_policy',
    'exchangeagreements': 'exchange_agreements',
    'mutualfundsdisclosure': 'mutual_funds_disclosure',
    'terms': 'bank_custody_terms_and_conditions',
    'bcmutualfundsdisclosure': 'bank_custody_mutual_funds_disclosure'
  },
  'copyrightTerms': {
    'copyrights': 'copyrights_tos',
    'investmenttermsandconditionschild': 'investment_terms_and_conditions',
    'termsconditions': 'terms_conditions'
  },
  'bestexecution': {
    'bestexecute': 'best_execution'
  },
  'sitesecurity': {
    'sitesecure': 'site_security',
    'onlineprivacystatement': 'online_privacy_statement',
    'nmiscustomerprivacynotice': 'nmis_customer_privacy_notice'
  },
  'emailencryption': {
    'emailencrypt': 'email_encryption'
  },
  'systemrequirements': {
    'systemrequire': 'systems_requirements'
  },
  'user-agreement': {
    'user-agreementchild': 'user_agreement'
  },
  'accountsafety': {
    'accountsafe': 'pas_keep_your_account_safe'
  },
  'nasdaqomxterms': 'nasdaq_omx_terms',
  'businesscontinuitydisclosure': {
    'businesscontinuity': 'business_continuity',
    'cpiibusinesscontinuitynotice': 'cpii_business_continuity'
  },
  'businesscontinuity': 'business_continuity',
  'cpiibusinesscontinuitynotice': 'cpii_business_continuity',
  'tradingdisclosure': {
    'exchangeagreements': 'exchange_agreements',
    'orderrouting': 'order_routing_disclosure',
    'stoporderrisksandvolatilemarkets': 'stop_order_risks_and_volatile_markets',
    'orderroutingsummary': 'order_routing_summary',
    'tradingUserAgreement':'trading_agreement',
	'fractionalSharesDisclosure':'fractional_shares_disclosures'
  },
  'trading': {
    'exchangeagreements': 'exchange_agreements',
    'orderrouting': 'order_routing_disclosure',
    'stoporderrisksandvolatilemarkets': 'stop_order_risks_and_volatile_markets',
    'orderroutingsummary': 'order_routing_summary',
    'fractionalSharesDisclosure':'fractional_shares_disclosures'
  },
  'assetprotectionfaqschild': 'asset_protection_faq',
  'privacy': 'privacy_policy',
  'copyrights': 'copyrights_tos',
  'sso-logout': 'sso_logout',
  'bestexecute': 'best_execution',
  'sitesecure': 'site_security',
  'emailencrypt': 'email_encryption',
  'systemrequire': 'systems_requirements',
  'user-agreementchild': 'user_agreement',
  'accountsafe': 'pas_keep_your_account_safe',
  'timeoutnotice': 'timeout_notice',
  'accessibilitystatement': 'accessibility_statement',
  'comericabusinesscontinuity': 'comerica_business_continuity',
  'sitespecificresource': 'site_specific_resources',
  'demovideo': 'cpwm_demo_video',
  'hfsdisclosures': {
    'hfsdisclose': 'hfs_disclosures'
  },
  'hfsdisclose': 'hfs_disclosures',
  'browserprivacysettings': {
    'browserprivacysettingschild' : 'browser_privacy_settings'
  },
  'comericabusinesscontinuitystatement': {
    'comericabusinesscontinuity': 'comerica_business_continuity'
  },
  'sitetermsandconditionsdeclined': {
    'sitetermsandconditionsdeclinedchild': 'site_terms_and_conditions_declined'
  },
  'investmenttermsandconditions': {
      'investmenttermsandconditionschild': 'investment_terms_and_conditions'
  },
  'investmenttermsandconditionschild': 'investment_terms_and_conditions',
  'legalinformation': 'additional_legal_information',
  'bnymconsumerprivacy': {
    'bnymconsumerprivacychild': 'dreyfus_consumer_privacy_policy'
  },
  'onlineagreement': {
    'onlineagreementchild': 'online_agreement'
  },
  'bnymbusinesscontinuity': {
    'bnymbusinesscontinuitychild': 'dreyfus_business_continuity'
  },
  'spagreement': {
    'spagreementchild': 's&p_agreement'
  },
  'iisprivacypolicy': {
    'iisprivacypolicychild': 'iis_privacy_policy',
    'spagreementchild': 'sp_agreement'
  }
};
